<template>
  <div class="content no-flex active">
    <ed-section
      :title="getTitle"
      class="no-flex active"
      wide
      full-width
    >
      <span slot="description">
        <div class="col-md-4 no-pad">
          {{ getSubtitle }}
        </div>
        <div class="clear"></div>
      </span>
      <br />
      <div>
        <p
          class="col-md-9 no-pad">
            For {{settings.divisionOrBUName}}
        </p>
        <div class="col-md-12 no-pad">
          <grid
            layout="frame"
            :class="{ simple: true }"
            :subtitle="`Subtitle Items`"
            label="Item"

            :search="false"
            :allow-export="false"
            :export-btn="false"
            :checkboxes="false"
            disable-filter
            :views="false"
            :pinning="false"
            :sorting="false"
            :dragRows="false"
            :fit-columns="true"
            :show-column-selector="false"
            auto-height="auto-height"

            :model="gridModel"
            :data="invoices"
            :key="initialLoad + fundingCurrencyChanged"
            :actions="actions"
            :rowDetailsComponent="settings.displayDivisionOnExpand ? InvoiceDetailsWithDivisionComponent : InvoiceDetailsComponent"

            remove-many="remove-many"
            clone-many="clone-many"
            :customDeleteManyButton="true"

            @changeRow="updateEventAmount"

            :totals="true"
            :total="getTotal"

            ref="PaymentInvoices"
            name='payment_invoices'
            :uid='`${uid}-${settings.divisionOrBUName}`'
            :canShowNotifications="!settings.isStep2"
          ></grid>
        </div>
      </div>
    </ed-section>
  </div>
</template>


<script>

import Grid from '@/components/Grid'
import { Eved } from '@/event-bus'
import { expand } from '@/components/Grid/cells/actions'
import InvoiceDetailsComponent from './components/InvoiceDetails'
import InvoiceDetailsWithDivisionComponent from './components/InvoiceDetailsWithDivision'
import paymentPriorityTag from './components/PaymentPriorityTag'

export default {
  components: {
    Grid
  },

  props: {
    invoices: Array,
    settings: Object
  },

  data () {
    return {
      initialLoad: false,
      fundingCurrencyChanged: 0,
      InvoiceDetailsComponent,
      InvoiceDetailsWithDivisionComponent,
      uid: this.$route.query.key
    }
  },

  created() {
    this.$on(Eved.PAYMENT.FUNDING_CURRENCY_CHANGED, () => {
      this.fundingCurrencyChanged++
    })
  },

  updated() {
    this.initialLoad = true
    this.$refs.PaymentInvoices.updateRowData()
  },

  computed: {
    getTitle() {
      return this.settings.title || ' '
    },

    getSubtitle() {
      return this.settings.subtitle || ''
    },

    actions() {
      return [expand]
    },

    gridModel() {
      let config = {
        SupplierName: {
          label: 'Supplier',
          width: 100,
          editable: false
        },
        '*InvoiceNumber': {
          label: 'Invoice',
          width: 100,
          editable: false
        },
        ProgramName: {
          label: global.app.$user.sessionSettings.CompanySettings.ProgramLabel,
          width: 100,
          editable: false
        },
        OriginalAmount: {
          label: 'OriginalAmount',
          editable: false,
          visible: false
        },
        PaymentPriority: {
          label: 'Payment Priority',
          width: 60,
          editable: false,
          visible: true,
          type: 'tags',
          render: paymentPriorityTag
        },
        Amount: {
          label: 'Amount',
          width: 60,
          editable: this.settings.editable,
          maxThreshold: {
            value: 0,
            f: 'OriginalAmount'
          },
          minThreshold: {
            value: 0
          }
        },
        details: {
          label: '+',
          details: 'local'
        },
        IsAmountDisabled: {
          label: 'IsAmountDisabled',
          type: utils.constants.columnType.Text,
          editable: false,
          visible: false
        }
      }

      if (!this.settings.isMakePayment || !this.isInvoiceCurrencyDifferentThanFundingCurrency()) {
        config.Amount.currency = this.settings.fundingCurrencyCode
        config.Amount.f = 'data.Amount'
      }

      if (this.settings.fundingCurrencyCode !== '' &&
        this.isInvoiceCurrencyDifferentThanFundingCurrency()) {
        config.AmountUSD = {
          label: this.getAmountUSDLabel(),
          width: 60,
          editable: false,
          currency: this.settings.fundingCurrencyCode,
          visible: this.settings.displayUSDEquivalent,
          f: 'data.AmountUSD'
        }
      }

      if (this.settings.editable === true) {
        config.Amount.editable = true

        if (this.settings.isMakePayment) {
          config.Amount.notEditableIf = {
            f: 'IsAmountDisabled'
          }

          config.Amount.infoMessage = params => {
            return params.data.IsNonEvedPayReady && !params.data.IsSameDayDeposit
              ? 'You are about to make payment to a supplier outside of the EvedPay network. At this time, we cannot make partial payments to those outside our network.'
              : null
          }
        }
      }

      return config
    },

    getTotal() {
      let paymentTotalAmount = 0
      this.invoices.map(inv => {
        if (!inv.IsSameDayDeposit) {
          if (!this.settings.isMakePayment ||
            (this.settings.fundingCurrencyCode && !this.isInvoiceCurrencyDifferentThanFundingCurrency())) {
            paymentTotalAmount += Number(inv.Amount)
          } else {
            paymentTotalAmount += Number(inv.AmountUSD)
          }
        }
      })
      return paymentTotalAmount
    }
  },

  methods: {
    isInvoiceCurrencyDifferentThanFundingCurrency(invoices) {
      let result = this.invoices &&
        this.invoices.find(i => i.CurrencyCode && this.settings.fundingCurrencyCode && i.CurrencyCode !== this.settings.fundingCurrencyCode)

      if (result) {
        return true
      } else {
        return false
      }
    },

    getAmountUSDLabel() {
      let currencyLabel = this.settings.fundingCurrencyCode || utils.constants.invoice.USD
      return currencyLabel + ' Equivalent'
    },

    async updateEventAmount(item) {
      let editedInvoice = this.invoices.find(inv =>
        inv.PaymentInvoiceId === item.data.PaymentInvoiceId
      )

      await this.updateModel(editedInvoice, item)
      this.isInvoiceCurrencyDifferentThanFundingCurrency() && this.emitCurrencyConversionEvent(item)

      this.$emit(Eved.PAYMENT.PAYMENT_AMOUNT_CHANGED, {})
    },

    updateModel(editedInvoice, item) {
      if (editedInvoice &&
        editedInvoice.Events !== null &&
        editedInvoice.Events.length > 0) {
        if (editedInvoice.Events.length > 1) {
          for (var i = 1; i < editedInvoice.Events.length; i++) {
            item.data.Amount -= editedInvoice.Events[i].Balance
          }
        }
        editedInvoice.Events[0].Balance = item.data.Amount
      }
    },

    emitCurrencyConversionEvent(item) {
      this.$emit(Eved.PAYMENT.MAKE_PAYMENT_CONVERSION, {
        CurrencyCode: this.settings.fundingCurrencyCode,
        PaymentInvoiceId: item.data.PaymentInvoiceId
      }, this.$refs.PaymentInvoices.updateRowData)
    }
  }
}

</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

.details-text {
  font-size: 12px;
  color: #51226c;
}

</style>



// WEBPACK FOOTER //
// src/components/_modules/Payment/Invoices.vue